/*
 * FMEPopups — lightweight coordinator for the store's overlays so they don't
 * open on top of each other (countdown modal, exit-intent modal, Crea chat).
 *
 * It is the single source of truth for "is a popup open" plus a tiny event bus:
 *   - Passive promos call FMEPopups.canOpen(name) before showing and bail if false.
 *   - Any overlay calls FMEPopups.markOpen(name) / markClose(name) around show/hide.
 *   - FMEPopups.onOtherOpen(name, closeFn) lets an open overlay yield when a
 *     user-initiated overlay (e.g. the chat) opens.
 *
 * Loaded globally with defer from layout/theme.liquid, before the section
 * scripts run, so window.FMEPopups exists by the time the popups initialise.
 * Every consumer still guards with `if (window.FMEPopups)` for safety.
 */
(function () {
  'use strict';

  // name -> true while that popup is open
  var openPopups = {};

  function anyOpenExcept(name) {
    for (var key in openPopups) {
      if (openPopups.hasOwnProperty(key) && openPopups[key] && key !== name) return true;
    }
    return false;
  }

  var FMEPopups = {
    /*
     * Should `name` be allowed to auto-open right now?
     * False if any other coordinated popup is open, or a Dawn modal
     * (cart drawer / quick-add / image zoom) has locked body scroll.
     */
    canOpen: function (name) {
      if (anyOpenExcept(name)) return false;
      if (document.body.classList.contains('overflow-hidden') && !openPopups[name]) return false;
      return true;
    },

    // isOpen(name) -> is that popup open; isOpen() -> is any popup open
    isOpen: function (name) {
      return name ? !!openPopups[name] : anyOpenExcept(null);
    },

    // Register a popup as open and notify the others.
    markOpen: function (name) {
      openPopups[name] = true;
      document.dispatchEvent(new CustomEvent('fme:popup:open', { detail: { name: name } }));
    },

    // Register a popup as closed and notify the others.
    markClose: function (name) {
      delete openPopups[name];
      document.dispatchEvent(new CustomEvent('fme:popup:close', { detail: { name: name } }));
    },

    /*
     * Run `closeFn` whenever a DIFFERENT popup opens while `name` is open,
     * so the currently-open overlay yields to a user-initiated one.
     */
    onOtherOpen: function (name, closeFn) {
      document.addEventListener('fme:popup:open', function (e) {
        if (e.detail && e.detail.name && e.detail.name !== name && openPopups[name]) {
          closeFn();
        }
      });
    }
  };

  window.FMEPopups = FMEPopups;
})();
